'use strict';

namespace Core {

    class AccountNav {

        private element: JQuery;
        private parentSidebar: ScSidebar;

        private user: any;
        private userName: string|undefined;
        private bookingId: string|undefined;
        private notifications: Dashboard.INotification[] = [];

        private settingsOpen: boolean = false;

        constructor (
            private $rootScope: ng.IRootScopeService,
            private $scope: ng.IScope,
            private authService: any,
            private dashboardNotificationService: any
        ) {
            $scope.$on('auth:signin', ()=> {
                this.refreshUser();
                this.parentSidebar.shut();
            });

            $scope.$on('auth:signout', ()=> {
                this.refreshUser();
                this.parentSidebar.shut();
            });
        }

        public refreshUser (): void {
            this.user = this.authService.getUser();

            // get user name
            this.userName = this.user.SignedIn ? this.user.FirstName : undefined;

            // get booking Id
            this.bookingId = this.user.AnonSignedIn
                ? `${this.user.Contact.SiteId}/${this.authService.getSignedInBookingId()}`
                : undefined;

            // get notifications
            if (this.user.AnonSignedIn || this.user.HardSignedIn) {
                this.dashboardNotificationService.getNotifications()
                    .then((notifications: Dashboard.INotification[]) => {
                    this.notifications = notifications;
                    this.$rootScope.alerts = notifications;
                });
            } else {
                this.notifications = [];
                this.$rootScope.alerts = null;
            }
        }

        public init (element: ng.IAugmentedJQuery, sidebar: ScSidebar): void {
            this.element = element;
            this.parentSidebar = sidebar;

            this.refreshUser();

            this.$scope.$watch('an.parentSidebar.isOpen', (val) => {
                // sidebar was opened - make sure user is up to date
                val && this.refreshUser();
            });

        }

        public signOut (): void {
            this.authService.signOut();
        }

        public close (): void {
            this.parentSidebar.toggle();
        }

        public openSettingsDialog (): void {
            this.settingsOpen = true;
            this.close();
        }

        public closeSettingsDialog (): void {
            this.settingsOpen = false;
        }

    }

    angular
        .module('core')
        .directive('accountNav', (): ng.IDirective => {
            return {
                scope: {},
                restrict: 'E',
                require: '^scSidebar',
                replace: true,
                transclude: true,
                controller: AccountNav,
                controllerAs: 'an',
                bindToController: {
                },
                templateUrl: `partials/home/directivetemplate?type=accountnav`,
                link: (
                    scope : ng.IScope,
                    el: ng.IAugmentedJQuery,
                    attr: ng.IAttributes,
                    controller: Core.ScSidebar
                ) => {
                    scope.an.init(el, controller);
                }
            };
        });
}
